import { NotificationReceiverTypeValue } from './notification-receiver-type';

/**
 * Thrown when a receiver identifier does not match its receiver type.
 *
 * An `Email` receiver must carry an email address and a `Web` receiver an
 * `idn-<uuid>` identity reference. The service rejects a mismatch before it
 * issues a request, because the notification API would store an unreachable
 * receiver rather than fail.
 *
 * This marks a caller error, not a transport failure. Callers that show a
 * message to the user can treat it the same as a failed write.
 */
export class InvalidNotificationReceiverError extends Error {
  public constructor(
    /**
     * The receiver type the identifier was validated against.
     */
    public readonly receiverType: NotificationReceiverTypeValue
  ) {
    super(`The receiver identifier is not a valid "${receiverType}" receiver.`);
    this.name = 'InvalidNotificationReceiverError';
  }
}
